export default __webpack_public_path__ + "static/media/CNo.41-2.9e32df91.jpg";